import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
      this.#updateItemsCount();
    }
  };

  open() {
    this.showDialog();
    this.#updateItemsCount();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }

  #updateItemsCount = async () => {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const data = await res.json();
      const count = Number(data?.item_count || 0);
      const label = count === 1 ? 'Item' : 'Items';
      const el = this.querySelector('#cart-items-text') || document.querySelector('#cart-items-text');
      if (el) el.textContent = `${count} ${label}`;
    } catch (e) {
      // silently ignore; fallback text remains
    }
  };
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
